import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ComponentBaseComponent } from '@app/core/components/component-base/component-base.component';
import { ModalService } from '@app/core/services/modal.service';
import { StateService } from '@app/core/services/state.service';
import { TranslateService } from '@app/core/services/translate.service';
import { DocArticleGet, DocArticleService } from '@app/services/doc-article.service';

@Component({
    selector: 'tt-doc-article-edit',
    templateUrl: './doc-article-edit.component.html',
    styleUrls: ['./doc-article-edit.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocArticleEditComponent extends ComponentBaseComponent implements OnInit, OnChanges {
    @Input()
    public params?: { docarticle_keyno: string | number };

    @Output()
    public submit = new EventEmitter<{ back: number; docarticle_keyno: string }>();

    public get?: DocArticleGet;

    public editorProcessing = false;

    public saving = false;

    public deleting = false;

    constructor(private docArticle: DocArticleService, private state: StateService, private modal: ModalService, private translate: TranslateService, private cdr: ChangeDetectorRef) {
        super();
    }

    public async saveDocArticle() {
        if (!!this.get) {
            try {
                this.saving = true;

                const serializedArticle: DocArticleGet = { ...this.get, html_content_base64: this.base64UrlEncodeUnicode(this.get.html_content_base64) };

                const { docarticle_keyno, errorcode, errormessage } = await this.docArticle.saveDocArticle(serializedArticle);

                if (errorcode !== '0') {
                    this.modal.show({ type: 'warning', title: 'error', translateTitle: true, message: errormessage });
                } else {
                    this.submit.emit({ back: 1, docarticle_keyno });
                    // this.state.back();
                }
            } catch (error) {
                console.error(error);
            } finally {
                this.saving = false;
            }
        }
    }

    public async deleteDocArticle() {
        if (!!this.get) {
            try {
                this.deleting = true;

                const { errorcode, errormessage } = await this.docArticle.deleteDocArticle(this.get.docarticle_keyno);

                if (errorcode !== '0') {
                    this.modal.show({ type: 'warning', title: 'error', translateTitle: true, message: errormessage });
                } else {
                    this.submit.emit({ back: 2, docarticle_keyno: '' + this.get.docarticle_keyno });
                    // this.state.back(2);
                }
            } catch (error) {
                console.error(error);
            } finally {
                this.deleting = false;
            }
        }
    }

    private async loadPageGet() {
        if (!!this.params) {
            this.get = await this.docArticle.getDocArticle(this.params.docarticle_keyno);
            this.get.html_content_base64 = this.base64UrlDecode(this.get.html_content_base64);
            this.cdr.markForCheck();
        }
    }

    ngOnInit(): void {
        // this.loadPageGet();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['params']) {
            this.loadPageGet();
        }
    }
}
